import React from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { AdaptiveStepper } from './DialogStepper';
import { DialogContentProps } from '../types';

// DialogContent: A component to structure the content of a dialog with a stepper
export const DialogContent = React.memo(
  ({
    children,
    steps,
    activeStep,
    onStepClick,
    hideSteps = false,
  }: DialogContentProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
      <Box
        data-testid="wizard-dialog-content"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Stepper section */}
        {!hideSteps && (
          <Box
            sx={{
              padding: isMobile ? theme.spacing(0) : theme.spacing(2, 0, 0, 0),
              backgroundColor: theme.palette.background.paper,
            }}
          >
            <AdaptiveStepper
              steps={steps}
              activeStep={activeStep}
              onStepClick={onStepClick}
            />
          </Box>
        )}

        {/* Content section */}
        <Box
          className="wizard-content"
          sx={{
            flexGrow: 1,
            overflowY: 'auto',
            padding: { xs: theme.spacing(2), md: theme.spacing('2px', 3, 3, 3) },
          }}
        >
          {children}
        </Box>
      </Box>
    );
  },
);
